// extracted by mini-css-extract-plugin
module.exports = {"SelectCategory":"SelectCategory_SelectCategory__WxjZU","active":"SelectCategory_active__3YnQJ"};